import { useState, useEffect } from 'react';
import {
  BOARD_STYLES,
  getCheckersPreferences,
  saveCheckersPreferences,
} from '../../services/checkersPreferencesService';
import './CheckersSettings.css';

const CheckersSettings = ({ user, onClose, onPreferencesChange }) => {
  const [preferences, setPreferences] = useState({
    boardStyle: 'green',
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (user) {
      loadPreferences();
    }
  }, [user]);

  const loadPreferences = async () => {
    const prefs = await getCheckersPreferences(user.uid);
    setPreferences(prefs);
  };

  const handleBoardStyleChange = (styleId) => {
    const newPrefs = { ...preferences, boardStyle: styleId };
    setPreferences(newPrefs);
    if (onPreferencesChange) {
      onPreferencesChange(newPrefs);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await saveCheckersPreferences(user.uid, preferences);
      if (onClose) {
        onClose();
      }
    } catch (error) {
      console.error('Error saving preferences:', error);
      alert('Failed to save preferences. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="checkers-settings-overlay">
      <div className="checkers-settings-dialog">
        <div className="checkers-settings-header">
          <h2>Board Customization</h2>
          <button className="close-settings-btn" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="checkers-settings-content">
          <h3>Board Style</h3>
          <div className="board-styles-grid">
            {BOARD_STYLES.map((style) => (
              <div
                key={style.id}
                className={`board-style-option ${
                  preferences.boardStyle === style.id ? 'selected' : ''
                }`}
                onClick={() => handleBoardStyleChange(style.id)}
              >
                <div className="board-preview">
                  <div
                    className="preview-square light"
                    style={{ backgroundColor: style.colors.light }}
                  ></div>
                  <div
                    className="preview-square dark"
                    style={{ backgroundColor: style.colors.dark }}
                  ></div>
                  <div
                    className="preview-square dark"
                    style={{ backgroundColor: style.colors.dark }}
                  ></div>
                  <div
                    className="preview-square light"
                    style={{ backgroundColor: style.colors.light }}
                  ></div>
                </div>
                <span className="style-name">{style.name}</span>
                {preferences.boardStyle === style.id && (
                  <span className="selected-check">✓</span>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="checkers-settings-footer">
          <button className="cancel-btn" onClick={onClose} disabled={saving}>
            Cancel
          </button>
          <button className="save-btn" onClick={handleSave} disabled={saving}>
            {saving ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CheckersSettings;
